import { render, staticRenderFns } from "./ColorsView.vue?vue&type=template&id=04119578"
import script from "./ColorsView.vue?vue&type=script&lang=js"
export * from "./ColorsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports